export const MILLISECONDS_FROM_END_TO_COUNT_AS_FINISHED = 15000
export const PROGRESS_UPDATE_INTERVAL = 1000
